<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="finish_audit" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_finish_audit_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-main"
                     *ngIf="!filtersets.main.hidden && !filtersets.main.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.main.collapsible }">
                    <div *ngIf="!filtersets.main.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.main.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.main.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.main.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.main.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.main.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.main.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-audit_entity" *ngIf="!filters.audit_entity.hidden && !filters.audit_entity.removed" 
                                  class="field-container standard {{filters.audit_entity.invalid ? 'invalid' : ''}} {{filters.audit_entity.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.audit_entity.styles.style"
                                  [ngClass]="filters.audit_entity.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.audit_entity.label + (filters.audit_entity.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.audit_entity.label}}<span *ngIf="filters.audit_entity.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <SerialNumbers-audit_entities_dd_single 
                                  data-cy="selector"
                                  [type]="filters.audit_entity.control.type"
                                  formControlName="audit_entity"
                                  (displayTextChange)="filters.audit_entity.control.displayText=$event"
                                  [placeholder]="filters.audit_entity.control.placeholder"
                                  [styles]="filters.audit_entity.control.styles"
                                  [tooltip]="filters.audit_entity.control.tooltip"
                              >
                              </SerialNumbers-audit_entities_dd_single>
                              <ng-container *ngIf="filters.audit_entity.invalid">
                                <ng-container *ngFor="let error of filters.audit_entity.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-warehouse" *ngIf="!filters.warehouse.hidden && !filters.warehouse.removed" 
                                  class="field-container standard {{filters.warehouse.invalid ? 'invalid' : ''}} {{filters.warehouse.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.warehouse.styles.style"
                                  [ngClass]="filters.warehouse.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.warehouse.label + (filters.warehouse.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.warehouse.label}}<span *ngIf="filters.warehouse.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Locations-warehouses_dd_single 
                                  data-cy="selector"
                                  [type]="filters.warehouse.control.type"
                                  formControlName="warehouse"
                                  (displayTextChange)="filters.warehouse.control.displayText=$event"
                                  [placeholder]="filters.warehouse.control.placeholder"
                                  [styles]="filters.warehouse.control.styles"
                                  [tooltip]="filters.warehouse.control.tooltip"
                              >
                              </Locations-warehouses_dd_single>
                              <ng-container *ngIf="filters.warehouse.invalid">
                                <ng-container *ngFor="let error of filters.warehouse.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-location" *ngIf="!filters.location.hidden && !filters.location.removed" 
                                  class="field-container standard {{filters.location.invalid ? 'invalid' : ''}} {{filters.location.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.location.styles.style"
                                  [ngClass]="filters.location.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.location.label + (filters.location.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.location.label}}<span *ngIf="filters.location.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Locations-locations_dd_single 
                                  data-cy="selector"
                                  [type]="filters.location.control.type"
                                  formControlName="location"
                                  (displayTextChange)="filters.location.control.displayText=$event"
                                  [placeholder]="filters.location.control.placeholder"
                                  [styles]="filters.location.control.styles"
                                  [tooltip]="filters.location.control.tooltip"
                                [warehouseId]="$fields_location_selector_inParams_warehouseId"
                                [typeId]="$fields_location_selector_inParams_typeId"
                              >
                              </Locations-locations_dd_single>
                              <ng-container *ngIf="filters.location.invalid">
                                <ng-container *ngFor="let error of filters.location.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-shipping_container" *ngIf="!filters.shipping_container.hidden && !filters.shipping_container.removed" 
                                  class="field-container standard {{filters.shipping_container.invalid ? 'invalid' : ''}} {{filters.shipping_container.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.shipping_container.styles.style"
                                  [ngClass]="filters.shipping_container.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.shipping_container.label + (filters.shipping_container.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.shipping_container.label}}<span *ngIf="filters.shipping_container.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <input data-cy="textBox" formControlName="shipping_container"
                                      matInput
                                      autocomplete="off"
                                      spellcheck="false"
                                      class="datex-textbox {{ (filters.shipping_container.control.readOnly || filters.shipping_container.control.disabled) ? 'readonly ' : ''}}"
                                      placeholder="{{filters.shipping_container.control.placeholder}}"
                                      [ngStyle]="filters.shipping_container.control.styles.style"
                                      [ngClass]="filters.shipping_container.control.styles.classes"
                                      [matTooltip]="filters.shipping_container.control.tooltip"
                                      matTooltipClass="datex-control-tooltip"> 
                              <ng-container *ngIf="filters.shipping_container.invalid">
                                <ng-container *ngFor="let error of filters.shipping_container.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-license_plate" *ngIf="!filters.license_plate.hidden && !filters.license_plate.removed" 
                                  class="field-container standard {{filters.license_plate.invalid ? 'invalid' : ''}} {{filters.license_plate.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.license_plate.styles.style"
                                  [ngClass]="filters.license_plate.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.license_plate.label + (filters.license_plate.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.license_plate.label}}<span *ngIf="filters.license_plate.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <input data-cy="textBox" formControlName="license_plate"
                                      matInput
                                      autocomplete="off"
                                      spellcheck="false"
                                      class="datex-textbox {{ (filters.license_plate.control.readOnly || filters.license_plate.control.disabled) ? 'readonly ' : ''}}"
                                      placeholder="{{filters.license_plate.control.placeholder}}"
                                      [ngStyle]="filters.license_plate.control.styles.style"
                                      [ngClass]="filters.license_plate.control.styles.classes"
                                      [matTooltip]="filters.license_plate.control.tooltip"
                                      matTooltipClass="datex-control-tooltip"> 
                              <ng-container *ngIf="filters.license_plate.invalid">
                                <ng-container *ngFor="let error of filters.license_plate.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-input_scan" *ngIf="!filters.input_scan.hidden && !filters.input_scan.removed" 
                                  class="field-container full {{filters.input_scan.invalid ? 'invalid' : ''}} {{filters.input_scan.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.input_scan.styles.style"
                                  [ngClass]="filters.input_scan.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.input_scan.label + (filters.input_scan.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.input_scan.label}}<span *ngIf="filters.input_scan.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <input data-cy="textBox" formControlName="input_scan"
                                      matInput
                                      autocomplete="off"
                                      spellcheck="false"
                                      class="datex-textbox {{ (filters.input_scan.control.readOnly || filters.input_scan.control.disabled) ? 'readonly ' : ''}}"
                                      placeholder="{{filters.input_scan.control.placeholder}}"
                                      [ngStyle]="filters.input_scan.control.styles.style"
                                      [ngClass]="filters.input_scan.control.styles.classes"
                                      [matTooltip]="filters.input_scan.control.tooltip"
                                      matTooltipClass="datex-control-tooltip"> 
                              <ng-container *ngIf="filters.input_scan.invalid">
                                <ng-container *ngFor="let error of filters.input_scan.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-notify_on_watch_list_match" *ngIf="!filters.notify_on_watch_list_match.hidden && !filters.notify_on_watch_list_match.removed" 
                                  class="field-container standard {{filters.notify_on_watch_list_match.invalid ? 'invalid' : ''}} {{filters.notify_on_watch_list_match.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.notify_on_watch_list_match.styles.style"
                                  [ngClass]="filters.notify_on_watch_list_match.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.notify_on_watch_list_match.label + (filters.notify_on_watch_list_match.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.notify_on_watch_list_match.label}}<span *ngIf="filters.notify_on_watch_list_match.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <mat-checkbox data-cy="checkBox" formControlName="notify_on_watch_list_match"
                                            class="datex-checkbox"
                                            color="primary"
                                            [ngStyle]="filters.notify_on_watch_list_match.control.styles.style"
                                            [ngClass]="filters.notify_on_watch_list_match.control.styles.classes"
                                            [matTooltip]="filters.notify_on_watch_list_match.control.tooltip"
                                            matTooltipClass="datex-control-tooltip">{{filters.notify_on_watch_list_match.control.label}}</mat-checkbox>
                              <ng-container *ngIf="filters.notify_on_watch_list_match.invalid">
                                <ng-container *ngFor="let error of filters.notify_on_watch_list_match.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-notify_duplicate_scan" *ngIf="!filters.notify_duplicate_scan.hidden && !filters.notify_duplicate_scan.removed" 
                                  class="field-container standard {{filters.notify_duplicate_scan.invalid ? 'invalid' : ''}} {{filters.notify_duplicate_scan.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.notify_duplicate_scan.styles.style"
                                  [ngClass]="filters.notify_duplicate_scan.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.notify_duplicate_scan.label + (filters.notify_duplicate_scan.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.notify_duplicate_scan.label}}<span *ngIf="filters.notify_duplicate_scan.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <mat-checkbox data-cy="checkBox" formControlName="notify_duplicate_scan"
                                            class="datex-checkbox"
                                            color="primary"
                                            [ngStyle]="filters.notify_duplicate_scan.control.styles.style"
                                            [ngClass]="filters.notify_duplicate_scan.control.styles.classes"
                                            [matTooltip]="filters.notify_duplicate_scan.control.tooltip"
                                            matTooltipClass="datex-control-tooltip">{{filters.notify_duplicate_scan.control.label}}</mat-checkbox>
                              <ng-container *ngIf="filters.notify_duplicate_scan.invalid">
                                <ng-container *ngFor="let error of filters.notify_duplicate_scan.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-notify_invalid_scan" *ngIf="!filters.notify_invalid_scan.hidden && !filters.notify_invalid_scan.removed" 
                                  class="field-container standard {{filters.notify_invalid_scan.invalid ? 'invalid' : ''}} {{filters.notify_invalid_scan.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.notify_invalid_scan.styles.style"
                                  [ngClass]="filters.notify_invalid_scan.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.notify_invalid_scan.label + (filters.notify_invalid_scan.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.notify_invalid_scan.label}}<span *ngIf="filters.notify_invalid_scan.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <mat-checkbox data-cy="checkBox" formControlName="notify_invalid_scan"
                                            class="datex-checkbox"
                                            color="primary"
                                            [ngStyle]="filters.notify_invalid_scan.control.styles.style"
                                            [ngClass]="filters.notify_invalid_scan.control.styles.classes"
                                            [matTooltip]="filters.notify_invalid_scan.control.tooltip"
                                            matTooltipClass="datex-control-tooltip">{{filters.notify_invalid_scan.control.label}}</mat-checkbox>
                              <ng-container *ngIf="filters.notify_invalid_scan.invalid">
                                <ng-container *ngFor="let error of filters.notify_invalid_scan.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-validate_against_material" *ngIf="!filters.validate_against_material.hidden && !filters.validate_against_material.removed" 
                                  class="field-container standard {{filters.validate_against_material.invalid ? 'invalid' : ''}} {{filters.validate_against_material.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.validate_against_material.styles.style"
                                  [ngClass]="filters.validate_against_material.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.validate_against_material.label + (filters.validate_against_material.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.validate_against_material.label}}<span *ngIf="filters.validate_against_material.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <mat-checkbox data-cy="checkBox" formControlName="validate_against_material"
                                            class="datex-checkbox"
                                            color="primary"
                                            [ngStyle]="filters.validate_against_material.control.styles.style"
                                            [ngClass]="filters.validate_against_material.control.styles.classes"
                                            [matTooltip]="filters.validate_against_material.control.tooltip"
                                            matTooltipClass="datex-control-tooltip">{{filters.validate_against_material.control.label}}</mat-checkbox>
                              <ng-container *ngIf="filters.validate_against_material.invalid">
                                <ng-container *ngFor="let error of filters.validate_against_material.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
              
                          <div class="fieldset-details" *ngIf="!filtersets.main.expanded">
              
              
                          </div>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.scanned_serials.hasTabToShow" class="tab" data-cy="tab-scanned_serials">
              <h2 [className]="tabs.scanned_serials.active? 'active': ''" (click)="tabs.scanned_serials.activate()">{{tabs.scanned_serials.title}}</h2>
            </div>
            <div *ngIf="tabs.watch_list.hasTabToShow" class="tab" data-cy="tab-watch_list">
              <h2 [className]="tabs.watch_list.active? 'active': ''" (click)="tabs.watch_list.activate()">{{tabs.watch_list.title}}</h2>
            </div>
          </div>
        
              <FootprintManager-audit_serial_numbers_grid *ngIf="tabs.scanned_serials.active"
              #$tabs_scanned_serials
              [scannedBarcodes]="$tabs_scanned_serials_audit_serial_numbers_grid_inParams_scannedBarcodes"
              [watchList]="$tabs_scanned_serials_audit_serial_numbers_grid_inParams_watchList"
              [context]="$tabs_scanned_serials_audit_serial_numbers_grid_inParams_context"
              (remove_serials)="remove_serials_from_scanned_barcodes($event)"
              ($refreshEvent)="refresh(false, false, '$tabs_scanned_serials')">
              </FootprintManager-audit_serial_numbers_grid>
              <FootprintManager-audit_serial_numbers_grid *ngIf="tabs.watch_list.active"
              #$tabs_watch_list
              [scannedBarcodes]="$tabs_watch_list_audit_serial_numbers_grid_inParams_scannedBarcodes"
              [watchList]="$tabs_watch_list_audit_serial_numbers_grid_inParams_watchList"
              [context]="$tabs_watch_list_audit_serial_numbers_grid_inParams_context"
              (remove_serials)="remove_serials_from_watch_list($event)"
              ($refreshEvent)="refresh(false, false, '$tabs_watch_list')">
              </FootprintManager-audit_serial_numbers_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>